import React from "react";
import "./RenderBulletImage.scss";

interface IProps {
  title: string;
  userList: IUser[];
  renderConnectedStatus?: boolean;
  cssClass?: string;
  cssStyle?: React.CSSProperties;
}

const Avatar: React.FC<{ user: IUser }> = ({ user }) => {
  const [imgError, setImgError] = React.useState(false);
  const shouldShowInitials = imgError || !user.photo_url;

  if (shouldShowInitials) {
    const name = user.name?.trim() || user.email?.split("@")[0] || "";
    let initials = name
      .split(" ")
      .map(word => word[0]?.toUpperCase())
      .slice(0, 2)
      .join("");

    if (initials.length === 1 && name.length > 1) {
      initials = name.substring(0, 2).toUpperCase();
    }

    return <span className="avatar-initials">{initials}</span>;
  }

  return (
    <img
      src={user.photo_url}
      alt={user.name}
      onError={() => setImgError(true)}
    />
  );
};

const BulletImageList: React.FC<IProps> = ({
  title,
  userList = [],
  renderConnectedStatus = false,
  cssClass = "",
  cssStyle = {}
}) => {
  const renderBulletImage = (user: IUser, index: number): React.JSX.Element => {
    const avatarClass = `avatar-content ${renderConnectedStatus
        ? user.connected
          ? "bullet online"
          : "bullet offline"
        : ""
      }`;

    return (
      <li
        key={user.email + user.invitation?.code}
        title={user.name || user.email}
        style={{ "--i": index } as React.CSSProperties}
        className="avatar-item"
      >
        <div className={avatarClass}>
          <Avatar user={user} />
        </div>
      </li>
    );
  };

  return (
    <div className={`bullet-image-list ${cssClass}`} style={cssStyle}>
      <h3 className="title">{title}</h3>
      <ul className="avatar-list">
        {userList.map((user, index) => renderBulletImage(user, index))}
      </ul>
    </div>
  );
};

export default BulletImageList;
